import { CoordinatorService } from "./coordinator.service"
import { ReportProject } from "./report-project"

export class Publication {
    id: string
    title: string
    description = ""
    type: "report"
    openAs: "viewer" | "editor"
    scriptLs?: string[]
    sourceId: string
    originClass: ReportProject
    private _isMemowlHub = false
    fileLs: string[] = []
    keywordLs: string[] = []

    constructor(private coords: CoordinatorService,
        public params: any) {
        this.id = params.id || this.coords.uniqueId()
        this.title = params.title || ""
        this.description = params.description || ""
        this.type = params.type
        this.sourceId = params.sourceId || ""
        this.originClass = params.originClass
        this._isMemowlHub = params.ownerId === "_memowl"
        this.openAs = params.openAs || "viewer"
        this.fileLs = params.files || []
        this.keywordLs = params.keywords || []

        this.scriptLs = params.scripts
        // console.log("publication", params, this)
    }

    get link() {
        return `/hub/${this.id}`
    }

    get isMemowl() {
        return this._isMemowlHub
    }

    get storagePath() {
        return `hub/${this.id}/${this.fileLs[0]}`
    }

    open() {
        this.coords.hub$.open(this)
    }

    dialog() {
        this.coords.display$.dialog$.next({
            action: "publication",
            publication: this
        })
    }
}
